<template>
    <svg
        id="Layer_1"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 512 512"
        style="enable-background: new 0 0 512 512"
        xml:space="preserve"
    >
        <circle style="fill: #d80027" cx="256" cy="256" r="256" />
        <polygon
            style="fill: #f0f0f0"
            points="389.565,211.479 300.522,211.479 300.522,122.435 211.478,122.435 211.478,211.479
	122.435,211.479 122.435,300.522 211.478,300.522 211.478,389.565 300.522,389.565 300.522,300.522 389.565,300.522 "
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "SwitzerlandFlagIcon",
});
</script>
